const _temp0 = require("../views/common/tags/errorMessage.view.js");
const _temp1 = require("../views/common/tags/flashMessage.view.js");
const _temp2 = require("../views/common/tags/localDebugging.view.js");


const _temp3 = require("../views/auth/verifyLogin/verifyLogin.view.js");


const _temp4 = require("../views/member/common/layout.view.js");

const _temp5 = require("../views/member/cardioExercises/catalogList/catalogList.view.js");

const _temp6 = require("../views/member/cardioExercises/list/list.view.js");


const _temp7 = require("../views/member/contributors/overview/overview.view.js");


const _temp8 = require("../views/member/gratitudeJournal/create/create.view.js");


const _temp9 = require("../views/member/home/welcome/welcome.view.js");


const _temp10 = require("../views/member/jointBalance/overview/overview.view.js");


const _temp11 = require("../views/member/repRanges/overview/overview.view.js");


const _temp12 = require("../views/member/resistanceExercises/catalogList/catalogList.view.js");

const _temp13 = require("../views/member/resistanceExercises/exerciseList/exerciseList.view.js");

const _temp14 = require("../views/member/resistanceExercises/merge/merge.view.js");

const _temp15 = require("../views/member/resistanceExercises/view/view.js");

const _temp16 = require("../views/member/resistanceExercises/instances/backfill/backfill.view.js");

const _temp17 = require("../views/member/resistanceExercises/instances/edit/edit.view.js");

const _temp18 = require("../views/member/resistanceExercises/instances/view/view.view.js");



const _temp19 = require("../views/member/workout/start/start.view.js");

const _temp20 = require("../views/member/workout/cardio/performExercise/performExercise.view.js");

const _temp21 = require("../views/member/workout/cardio/selectExercise/selectExercise.view.js");

const _temp22 = require("../views/member/workout/cardio/selectRecentExercise/selectRecentExercise.view.js");


const _temp23 = require("../views/member/workout/resistance/selectExercise/selectExercise.view.js");

const _temp24 = require("../views/member/workout/resistance/performExercise/performExercise.view.js");

const _temp25 = require("../views/member/workout/resistance/selectRecentExercise/selectRecentExercise.view.js");




module.exports = {
  "common":   {
    "tags":     {
      "errorMessage.view": _temp0,
      "flashMessage.view": _temp1,
      "localDebugging.view": _temp2
    }
  },
  "auth":   {
    "verifyLogin":     {
      "verifyLogin.view": _temp3
    }
  },
  "member":   {
    "common":     {
      "layout.view": _temp4
    },
    "cardioExercises":     {
      "catalogList":       {
        "catalogList.view": _temp5
      },
      "list":       {
        "list.view": _temp6
      }
    },
    "contributors":     {
      "overview":       {
        "overview.view": _temp7
      }
    },
    "gratitudeJournal":     {
      "create":       {
        "create.view": _temp8
      }
    },
    "home":     {
      "welcome":       {
        "welcome.view": _temp9
      }
    },
    "jointBalance":     {
      "overview":       {
        "overview.view": _temp10
      }
    },
    "repRanges":     {
      "overview":       {
        "overview.view": _temp11
      }
    },
    "resistanceExercises":     {
      "catalogList":       {
        "catalogList.view": _temp12
      },
      "exerciseList":       {
        "exerciseList.view": _temp13
      },
      "merge":       {
        "merge.view": _temp14
      },
      "view":       {
        "view": _temp15
      },
      "instances":       {
        "backfill":         {
          "backfill.view": _temp16
        },
        "edit":         {
          "edit.view": _temp17
        },
        "view":         {
          "view.view": _temp18
        }
      }
    },
    "workout":     {
      "start":       {
        "start.view": _temp19
      },
      "cardio":       {
        "performExercise":         {
          "performExercise.view": _temp20
        },
        "selectExercise":         {
          "selectExercise.view": _temp21
        },
        "selectRecentExercise":         {
          "selectRecentExercise.view": _temp22
        }
      },
      "resistance":       {
        "selectExercise":         {
          "selectExercise.view": _temp23
        },
        "performExercise":         {
          "performExercise.view": _temp24
        },
        "selectRecentExercise":         {
          "selectRecentExercise.view": _temp25
        }
      }
    }
  }
}